<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('settings')">Settings</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> 
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('import-sources.index')">Import Sources</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ importSource.name }}
    </h1>

    <div class="flex flex-wrap">
      <div class="w-full lg:w-1/2 px-2">
        <card>
          <div class="p-6 flex flex-wrap">
            <div class="pb-8 w-full"><span class="font-semibold block">Name:</span>{{ importSource.name }}</div>
            <div class="pb-8 w-full"><span class="font-semibold block">Base URI:</span>{{ importSource.base_uri }}</div>
            <div class="pb-8 w-full lg:w-1/2"><span class="font-semibold block">Type:</span>{{ importSource.type }}</div>
            <div class="pb-8 w-full lg:w-1/2"><span class="font-semibold block">Status:</span>{{ importSource.status }}</div>
          </div>

          <template v-slot:footer>
            <button v-if="!importSource.deleted_at && can.delete" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Import Source</button>
            <inertia-link v-if="can.edit" class="btn-indigo ml-auto" :href="route('import-sources.edit', importSource.id)">Edit Import Source</inertia-link>
          </template>
        </card>
      </div>

      <div class="w-full lg:w-1/2 px-2">
        <table-wrapper :headers="['ID', 'Title', 'Entries']" :text-wrap="false" class="mb-4">
          <table-row v-for="form in forms" :key="form.id">
            <table-cell>{{ form.id }}</table-cell>
            <table-cell>{{ form.title }}</table-cell>
            <table-cell colspan="2">{{ form.entries }}</table-cell>
          </table-row>

          <table-row v-if="forms.length === 0">
            <table-cell colspan="4">
              No Forms Found
            </table-cell>
          </table-row>
        </table-wrapper>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"

export default {
  metaInfo() {
    return { title: this.importSource.name }
  },
  components: {
    SelectInput,
    TextInput,
    TrashedMessage,
    LoadingButton,
    Icon,
    Card,
    CardListItem,
    TableWrapper,
    TableRow,
    TableCell
  },
  props: {
    importSource: Object,
    forms: Array,
    can: Object,
  },
  layout: Layout,
  methods: {
    destroy() {
      if (confirm('Are you sure you want to delete this import source?')) {
        this.$inertia.delete(this.route('import-sources.destroy', this.importSource.id))
      }
    },
  },
}
</script>
